import React, { useState, useEffect } from "react";
import { MyContext } from "../../DashClienteMainScreen";
import { useContext } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import request from "../../../../../Helpers/API";

import { IconButton } from "@mui/material";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { FormatMoney } from "../../../../../Helpers/FormatNumber";
import { onHomeDashClientes } from "../onOpenScreenDashCliente";
import { LoaderScreen } from "../../../../components/LoaderScreen";

export const SolicitudCreditoListadoScreen = () => {
  const history = useHistory();
  const location = useLocation();
  // Este componente se usa tanto dentro de DashClienteMainScreen (idcliente vía MyContext)
  // como dentro de CRMMainScreen (sin ese Provider); si no hay contexto, se usan valores por defecto.
  const context = useContext(MyContext);
  const state = context?.state || {};
  const setState = context?.setState || (() => { });
  // idcliente llega por location.state (navegación desde CRM_Dashboard) o, si no, por el contexto
  const idcliente = location.state?.idcliente ?? state.idcliente;
  const cliente = location.state?.cliente ?? state.cliente;
  const [stateSolicitud, setStateSolicitud] = useState({
    solicitudes: [],
  });

  // folio/tipoSolicitud presentes = edición; ausentes = solicitud nueva (folio 0)
  const onSiguiente = (folio = 0, tipoSolicitud = "", idclienteOverride) => {
    history.push("/DashClientes/solicitudcreditoGenerar", {
      idcliente: idclienteOverride ?? idcliente,
      cliente: cliente,
      folio,
      tipo_solicitud: tipoSolicitud,
    });
  };
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    setState({
      ...state,
      folio: "",
    });
    request
      .get(`SolicitudCredito/Listado/${idcliente}`)
      .then((result) => {
        setStateSolicitud({
          ...stateSolicitud,
          solicitudes: result,
        });
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `Algo salió mal: ${error.message}`,
        });
      });
  }, [idcliente]);
  const onEdit = (folio, idclienteFila, solicitud) => {
    setState({
      ...state,
      folio: folio,
      idcliente: idclienteFila,
      tipo_solicitud: solicitud,
    });
    onSiguiente(folio, solicitud, idclienteFila);
  };
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  };
  return (
    <div className="crm-main-screen">
      <div className="crm-body">
        <div className="crm-page">
          <div className="crm-module">
            <div className="crm-module-head">
              <div className="crm-head-grid">
                <div className="crm-head-left">
                  <button
                    className="crm-btn-regresar"
                    onClick={() => {
                      onHomeDashClientes();
                      history.push("/DashClientes/Main", { idcliente });
                    }}
                  >
                    <ArrowBackIcon /> Regresar
                  </button>
                </div>
                <div className="crm-head-center">
                  <h1 className="crm-module-title">SOLICITUDES DE CRÉDITO</h1>
                  <p className="crm-module-subtitle">{cliente?.toUpperCase() ?? ""}</p>
                </div>
                <div className="crm-head-right">
                  <button className="crm-btn-action" onClick={() => onSiguiente()}>
                    <AddCircleIcon fontSize="small" /> Nueva Solicitud
                  </button>
                </div>
              </div>
              <div className="crm-head-divider">
                <div className="crm-head-divider-dot" />
              </div>
            </div>
            <div className="Dash-solicitud-credito-listado">
              <LoaderScreen loader={loader} />
              <div className="sc-listado-tabla-section scroll">
                <div className="sc-listado-tabla-head">
                  <div>Folio</div>
                  <div>Tipo de Solicitud</div>
                  <div>Importe</div>
                  <div>Estado</div>
                  <div></div>
                </div>
                {stateSolicitud.solicitudes.map((solicitud) => (
                  <div key={solicitud.folio} className="sc-listado-tabla-row">
                    <div className="sc-cell-text">{solicitud.folio}</div>
                    <div className="sc-cell-text">{capitalizeWords(solicitud.tipo_solicitud)}</div>
                    <div className="sc-cell-importe">{FormatMoney(solicitud.importe)}</div>
                    <div className="sc-cell-text">{capitalizeWords(solicitud.estatus)}</div>
                    <div className="sc-cell-action">
                      <IconButton
                        color="warning"
                        onClick={() => onEdit(solicitud.folio, solicitud.idcliente, solicitud.solicitud)}
                      >
                        <EditIcon />
                      </IconButton>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
